import { render, staticRenderFns } from "./AboutGiftCardsSection.vue?vue&type=template&id=33fac6b9&scoped=true&"
import script from "./AboutGiftCardsSection.vue?vue&type=script&lang=js&"
export * from "./AboutGiftCardsSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutGiftCardsSection.vue?vue&type=style&index=0&id=33fac6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fac6b9",
  null
  
)

export default component.exports